import clsx from 'clsx'
import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { useLocalStorage } from '@/context/localstorage-context'

export default function BtnContainer({ children }: { children: ReactNode }) {
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])
  const btnCln = clsx('w-full flex justify-around mt-[20px]', {
    'btn1-light': !isDark,
    'btn1-dark': isDark,
  })

  return <div className={btnCln}>{children}</div>
}
